import { Reducer } from 'redux'
import { PagesStateActionTypes } from '../actions'
import { PagesStoreModel, initialPagesState, PageStateStoreModel } from '../store.model'

export const pagesStateReducer: Reducer<PagesStoreModel> = (state = initialPagesState, action) => {
  switch (action.type) {
    case PagesStateActionTypes.STORE_DATATABLE_FILTER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          dataTableFilter: action.payload.filter ? action.payload.filter : undefined
        }
      ]
    case PagesStateActionTypes.STORE_DATATABLE_ROWS_PER_PAGE:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          dataTableRowsPerPage: action.payload.rowsPerPage ? action.payload.rowsPerPage : undefined
        }
      ]
    case PagesStateActionTypes.STORE_DATATABLE_SEARCH:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          dataTableSearch: action.payload.search || undefined
        }
      ]
    case PagesStateActionTypes.STORE_DATE_FILTER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          dataTableFilter: [],
          dataTableSearch: undefined,
          dateFilter: action.payload.filter ? action.payload.filter : undefined,
          customFilter: undefined
        }
      ]
    case PagesStateActionTypes.STORE_CUSTOM_FILTER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          dataTableFilter: [],
          dataTableSearch: undefined,
          dateFilter: undefined,
          customFilter: action.payload.filter ? action.payload.filter : undefined
        }
      ]
    case PagesStateActionTypes.STORE_ACTIVE_TAB:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          activeTab: action.payload.tab
        }
      ]
    case PagesStateActionTypes.STORE_ACTIVE_TAB_POWER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          activeTabPower: action.payload.tab
        }
      ]
    case PagesStateActionTypes.STORE_COMMODITY_FILTER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          commodityFilter: action.payload.filter
        }
      ]
    case PagesStateActionTypes.STORE_ACTIVES_FILTER:
      return [
        ...state.filter((pageState: PageStateStoreModel) => pageState.page !== action.payload.page),
        {
          ...state.filter(
            (pageState: PageStateStoreModel) => pageState.page === action.payload.page
          )[0],
          page: action.payload.page,
          showOnlyActivesFilter: action.payload.isActive
        }
      ]
    default:
      return state
  }
}
